export default {
    apiBaseUrl: process.env.REACT_APP_MASTER_API_BASE_URL,
    log: false,
    trackHttpTimeInConsole: false, // Works when log is true
    trackHttpResponseInConsole: false, // Works when log is true,
};